import { cva } from 'class-variance-authority';

const inputVariants = cva(
  'flex rounded-sm shadow-sm border border-border bg-background leading-tight text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'w-full h-12 min-h-12 px-3',
        large: 'w-full h-14 min-h-14 px-3',
        small: 'w-full h-10 min-h-10 px-3',
        extraSmall: 'w-full h-8 min-h-8 px-3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const iconVariants = cva(
  'absolute top-1/2 -translate-y-1/2 grid place-items-center [&_svg]:w-4 [&_svg]:h-4',
  {
    variants: {
      variant: {
        small: 'left-3',
        default: 'left-3',
        large: 'left-4',
        extraSmall: 'left-3',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export { iconVariants, inputVariants };
